module.exports = __webpack_public_path__ + "media/images/icon__checkmark@2x-c26672679fda126640a3d57e5c4976a2.png";